import crewBoardWordmark from '../assets/crew/lctf-wordmark.png';

/** Still photos for the public raise-crew board. Drop files in `public/crew-jobs/`. */
export const CREW_BOARD_MEDIA = {
  hero: '/crew-jobs/crew.jpg',
  crew: '/crew-jobs/crew.jpg',
  joinery: '/crew-jobs/joinery.jpg',
  logo: crewBoardWordmark,
  logoFallback: '/assets/logo/LCTF%20Profile.png',
  raisingVideo: '/videos/journey-crew-raising.mp4',
} as const;

export const CREW_BOARD_HERO_SLOTS = 3;
export const CREW_BOARD_HERO_ROTATE_MS = 8000;

export type CrewBoardPhoto = { url: string; name: string };

export function resolveCrewBoardHeroUrl(url?: string | null): string {
  const trimmed = typeof url === 'string' ? url.trim() : '';
  return trimmed || CREW_BOARD_MEDIA.hero;
}

function photoUrl(photo?: CrewBoardPhoto | null): string {
  return typeof photo?.url === 'string' ? photo.url.trim() : '';
}

/** Up to three custom header stills. Empty slots are skipped. Falls back to the legacy single photo, then the default crane shot. */
export function resolveCrewBoardHeroUrls(
  heroes?: Array<CrewBoardPhoto | null | undefined> | null,
  fallbackSingle?: string | null
): string[] {
  const fromSlots = (Array.isArray(heroes) ? heroes : [])
    .map(photoUrl)
    .filter(Boolean);
  if (fromSlots.length) return fromSlots;
  return [resolveCrewBoardHeroUrl(fallbackSingle)];
}

export function padCrewBoardHeroSlots(
  heroes?: Array<CrewBoardPhoto | null | undefined> | null,
  fallbackSingle?: CrewBoardPhoto | null
): Array<CrewBoardPhoto | null> {
  const slots: Array<CrewBoardPhoto | null> = Array.from({ length: CREW_BOARD_HERO_SLOTS }, () => null);
  const source = Array.isArray(heroes) ? heroes : [];
  source.slice(0, CREW_BOARD_HERO_SLOTS).forEach((photo, i) => {
    slots[i] = photoUrl(photo) ? { url: photoUrl(photo), name: photo?.name || 'Header photo' } : null;
  });
  if (!slots.some(Boolean) && photoUrl(fallbackSingle)) {
    slots[0] = { url: photoUrl(fallbackSingle), name: fallbackSingle?.name || 'Header photo' };
  }
  return slots;
}

export type CrewBoardQuote = {
  author: string;
  role: string;
  text: string;
};

export function crewBoardQuoteStartIndex(quotes: CrewBoardQuote[] = CREW_BOARD_QUOTES): number {
  const found = quotes.findIndex(quote => /shackleton/i.test(quote.author));
  return found >= 0 ? found : 0;
}

export const CREW_BOARD_QUOTES: CrewBoardQuote[] = [
  {
    author: 'Sir Ernest Shackleton',
    role: 'Explorer',
    text: 'Men wanted for hazardous journey. Small wages, bitter cold, long months of complete darkness, constant danger, safe return doubtful. Honour and recognition in case of success.',
  },
  {
    author: 'Theodore Roosevelt',
    role: 'The arena, 1910',
    text: 'The credit belongs to the man who is actually in the arena, whose face is marred by dust and sweat and blood; who strives valiantly; who errs, who comes short again and again.',
  },
  {
    author: 'St. Benedict',
    role: 'The Rule, ch. 48',
    text: 'Idleness is the enemy of the soul. Therefore the brothers ought to be occupied at certain times in manual labor, and again at certain hours in sacred reading.',
  },
  {
    author: 'Antoine de Saint-Exupéry',
    role: 'Citadelle',
    text: 'A rock pile ceases to be a rock pile the moment a single man contemplates it, bearing within him the image of a cathedral.',
  },
  {
    author: 'Marcus Aurelius',
    role: 'Meditations',
    text: 'The impediment to action advances action. What stands in the way becomes the way.',
  },
];
